// valida que no excedan 1 mes entre cada fecha de pago
export function validarFechasPagos(datos) {
  const MILIS_DIA = 1000 * 60 * 60 * 24;
  const errores = [];

  for (const item of datos) {
    const pagos = item.pagos;

    if (!pagos || pagos.length <= 2) continue; // Si solo hay un pago, no hay nada que comparar

    // Ordenar los pagos por fecha (por si vienen desordenados)
    const fechas = pagos
      .map(p => convertirFecha(p.fecha_pago))
      .sort((a, b) => a - b);

    // Revisar diferencias entre fechas consecutivas
    // i=2 ignoramos entre la primera y segunda cuota 
    for (let i = 3; i < fechas.length; i++) {
      const diffDias = Math.abs((fechas[i] - fechas[i - 1]) / MILIS_DIA);
      if (diffDias > 32) {
        errores.push({
          cobro_programa_id: item.cobro_programa_id,
          nombre: item.nombre,
          cuotaAnterior: i,
          cuotaSiguiente: i + 1,
          diferenciaDias: diffDias.toFixed(0)
        });
      }
    }
  }

  return errores;
}

// Función auxiliar para convertir "dd/MM/yyyy" → Date
function convertirFecha(fechaStr) {
  const [dia, mes, anio] = fechaStr.split('/').map(Number);
  return new Date(anio, mes - 1, dia);
}



export function validarPlanPagosOnEditar(planPagos) {
  const MILIS_DIA = 1000 * 60 * 60 * 24;
  const errores = [];

  // Agrupar pagos por concepto_pago_id
  const grupos = planPagos.reduce((acc, pago) => {
    if (!acc[pago.concepto_pago_id]) acc[pago.concepto_pago_id] = [];
    acc[pago.concepto_pago_id].push(pago);
    return acc;
  }, {});

  // Validar cada grupo
  for (const [conceptoId, pagos] of Object.entries(grupos)) {
    if (pagos.length <= 2) continue; // Solo una cuota, nada que validar

    // Ordenar por fecha
    const fechas = pagos
      .map(p => new Date(p.fecha_pago))
      .sort((a, b) => a - b);

    // Revisar diferencias
    for (let i = 3; i < fechas.length; i++) {
      const diffDias = Math.abs((fechas[i] - fechas[i - 1]) / MILIS_DIA);
    //   window.console.log('mod_monto',!pagos[i - 1].mod_fecha);
    //   window.console.log('diffDias',diffDias);
      // se usa !pagos[i - 1].mod_fecha, ya que cuando es true el campo fecha de
      // la vista se vuelve disabled
      if (diffDias > 32 && !pagos[i - 1].mod_fecha) {
        errores.push({
          concepto_pago_id: Number(conceptoId),
          nombre: pagos[i].concepto_pago,
          cuotaAnterior: i,
          cuotaSiguiente: i + 1,
          diferenciaDias: diffDias.toFixed(0),
        }); 
      }
    }
  }

  return errores;
}